import { PhoneModel } from "src/app/models/common/phone-model";
import { StateNestedModel } from "src/app/models/common/statemodel";
import { UserRole } from "src/app/models/common/user-role";
import { CountryModel } from "src/app/models/common/countrymodel";
import { RejectionReasonModel } from "src/app/models/common/myteam-model";
import { CreatedBy } from "../../external-dashboards/quoteTable/base-quote.model";

export interface IInviteModelForLeadVerification {
    id: string;
    state: StateNestedModel;
    updated_at?: Date;
    created_at?: Date;
    is_active: boolean;
    email: string;
    first_name: string;
    last_name: string;
    phone: PhoneModel;
    company_name: string;
    address: string;
    has_registered: boolean;
    is_otp_verified: boolean;
    is_login_approved: boolean;
    rejection_reason: string;
    remarks: string;
    approval_status: string;
    created_by?: null;
    updated_by?: null;
    role: UserRole;
    company: ILeadCompanyModel;
    country: CountryModel;
    otp_verified_at?: Date;
    bypass_external_verification: boolean;
    approved_rejected_by: CreatedBy;
    approved_rejected_at: Date;
}

export interface ILeadInviteModelErrors {
    id: string[];
    state: string[];
    updated_at: string[];
    created_at: string[];
    is_active: string[];
    email: string[];
    first_name: string[];
    last_name: string[];
    phone: string[];
    company_name: string[];
    address: string[];
    has_registered: string[];
    is_otp_verified: string[];
    is_login_approved: string[];
    rejection_reason: string[];
    remarks: string[];
    approval_status: string[];
    created_by: string[];
    updated_by: string[];
    role: string[];
    company: string[];
    country: string[];
    bypass_external_verification: string[];
}

export class LeadInviteModelErrors {
    id: string[];
    state: string[];
    updated_at: string[];
    created_at: string[];
    is_active: string[];
    email: string[];
    first_name: string[];
    last_name: string[];
    phone: string[];
    company_name: string[];
    address: string[];
    has_registered: string[];
    is_otp_verified: string[];
    is_login_approved: string[];
    rejection_reason: string[];
    remarks: string[];
    approval_status: string[];
    created_by: string[];
    updated_by: string[];
    role: string[];
    company: string[];
    country: string[];
    bypass_external_verification: string[];

    constructor() {
        this.id = [];
        this.state = [];
        this.updated_at = [];
        this.created_at = [];
        this.is_active = [];
        this.email = [];
        this.first_name = [];
        this.last_name = [];
        this.phone = [];
        this.company_name = [];
        this.address = [];
        this.has_registered = [];
        this.is_otp_verified = [];
        this.is_login_approved = [];
        this.rejection_reason = [];
        this.remarks = [];
        this.approval_status = [];
        this.created_by = [];
        this.updated_by = [];
        this.role = [];
        this.company = [];
        this.country = [];

        this.resetLeadInviteError();
    }

    resetLeadInviteError() {
        return {
            id: [],
            state: [],
            updated_at: [],
            created_at: [],
            is_active: [],
            email: [],
            first_name: [],
            last_name: [],
            phone: [],
            company_name: [],
            address: [],
            has_registered: [],
            is_otp_verified: [],
            is_login_approved: [],
            rejection_reason: [],
            remarks: [],
            approval_status: [],
            created_by: [],
            updated_by: [],
            role: [],
            company: [],
            country: [],
        }
    }
}

export class InviteModelForLeadVerification {
    id: string;
    state: StateNestedModel;
    updated_at: Date;
    created_at: Date;
    is_active: boolean;
    email: string;
    first_name: string;
    last_name: string;
    phone: PhoneModel;
    company_name: any;
    address: string;
    has_registered: boolean;
    is_otp_verified: boolean;
    is_login_approved: any;
    rejection_reason: RejectionReasonModel;
    remarks: string;
    approval_status: string;
    created_by: null;
    updated_by: null;
    role: UserRole;
    company: ILeadCompanyModel;
    country: CountryModel;
    bypass_external_verification: boolean;

    client_browser?: string;
    client_device?: string;
    client_location?: string;
    client_ip?: string;
    otp_verified_at?: Date;
    approved_rejected_by?: CreatedBy;
    approved_rejected_at?: Date;

    error: ILeadInviteModelErrors;

    loginApprovalList = [
        {
            id: 'yes',
            value: 'Yes'
        },
        {
            id: 'no',
            value: 'No'
        },
        {
            id: 'under_process',
            value: 'In Process'
        }
    ]

    loginApprovalList_Up = [
        {
            id: 'yes',
            value: 'Yes'
        },
        {
            id: 'no',
            value: 'No'
        }
    ]

    constructor(data = null) {
        this.id = data ? data.id : null;
        this.state = data ? data.state : null;
        this.updated_at = data ? data.updated_at : null;
        this.created_at = data ? data.created_at : null;
        this.is_active = data ? data.is_active : null;
        this.email = data ? data.email : null;
        this.first_name = data ? data.first_name : null;
        this.last_name = data ? data.last_name : null;
        this.phone = data ? data.phone : null;
        this.company_name = data ? data.company_name : null;
        this.address = data ? data.address : null;
        this.has_registered = data ? data.has_registered : null;
        this.is_otp_verified = data ? data.is_otp_verified : null;
        this.is_login_approved = data ? data.approval_status == 'rejected' ? this.loginApprovalList[1] : this.loginApprovalList[0] : null;
        this.rejection_reason = data ? data.rejection_reason : null;
        this.remarks = data ? data.remarks : null;
        this.approval_status = data ? data.approval_status : null;
        this.created_by = data ? data.created_by : null;
        this.updated_by = data ? data.updated_by : null;
        this.role = data ? data.role : null;
        this.company = data ? data.company : null;
        this.country = data ? data.country : null;

        this.client_browser = data ? data.client_browser : null;
        this.client_device = data ? data.client_device : null;
        this.client_location = data ? data.client_location : null;
        this.client_ip = data ? data.client_ip : null;
        this.otp_verified_at = data ? data.otp_verified_at : null;
        this.approved_rejected_by = data ? data.approved_rejected_by : null;
        this.approved_rejected_at = data ? data.approved_rejected_at : null;

        this.bypass_external_verification = false;

        this.resetLeadInviteError();
    }

    saveFirstPayload(data) {
        this.id = data.id;
        this.state = data.state
        this.updated_at = data.updated_at;
        this.created_at = data.created_at;
        this.is_active = data.is_active;
        this.email = data.email;
        this.first_name = data.first_name;
        this.last_name = data.last_name;
        this.phone = data.phone;
        this.company_name = data.company_name;
        this.address = data.address;
        this.has_registered = data.has_registered;
        this.is_otp_verified = data.is_otp_verified;
        this.is_login_approved = null;
        this.rejection_reason = data.rejection_reason;
        this.remarks = data.remarks;
        this.approval_status = data.approval_status;
        this.created_by = data.created_by;
        this.updated_by = data.updated_by;
        this.role = data.role;
        this.company = data.company;
        this.country = data.country;

        this.client_browser = data.client_browser;
        this.client_device = data.client_device;
        this.client_location = data.client_location;
        this.client_ip = data.client_ip;
        this.otp_verified_at = data.otp_verified_at;

        this.bypass_external_verification = false;
    }
    resetLeadInviteError() {
        this.error = {
            id: [],
            state: [],
            updated_at: [],
            created_at: [],
            is_active: [],
            email: [],
            first_name: [],
            last_name: [],
            phone: [],
            company_name: [],
            address: [],
            has_registered: [],
            is_otp_verified: [],
            is_login_approved: [],
            rejection_reason: [],
            remarks: [],
            approval_status: [],
            created_by: [],
            updated_by: [],
            role: [],
            company: [],
            country: [],
            bypass_external_verification: [],
        }
    }

    is_user_valid() {
        this.resetLeadInviteError();

        if (this.is_login_approved) {
            if (this.first_name == null || this.first_name == '') {
                this.error.first_name.push('First name is required');
            }

            if (this.last_name == null || this.last_name == '') {
                this.error.last_name.push('Last name is required');
            }

            if (this.company == null) {
                this.error.company.push('Company is required');
            }

            if (this.role == null) {
                this.error.role.push('Role is required');
            }

            if (this.country == null) {
                this.error.country.push('Country is required');
            }

            if (this.state == null) {
                this.error.state.push('State is required');
            }

            return this.error.first_name.length == 0 &&
                this.error.last_name.length == 0 &&
                this.error.email.length == 0 &&
                this.error.company.length == 0 &&
                this.error.role.length == 0 &&
                this.error.country.length == 0 &&
                this.error.state.length == 0
        } else {
            if (this.rejection_reason == null) {
                this.error.rejection_reason.push('Decline reason is required');
            }

            if (this.remarks == null || this.remarks == '') {
                this.error.remarks.push('Remarks is required');
            }

            return this.error.rejection_reason.length == 0 &&
                this.error.remarks.length == 0
        }

    }

    getUserVerificationSavePayload() {
        if (this.is_login_approved) {
            return {
                id: this.id,
                state: typeof this.state == 'object' && this.state != null ? this.state.id : this.state,
                is_active: this.is_active,
                email: this.email,
                first_name: this.first_name,
                last_name: this.last_name,
                phone: typeof this.phone == 'object' && this.phone != null ? this.phone.as_e164 : this.phone,
                company_name: this.company_name,
                address: this.address,
                has_registered: this.has_registered,
                is_otp_verified: this.is_otp_verified,
                // is_login_approved: this.is_login_approved,
                is_login_approved: typeof this.is_login_approved == 'object' && this.is_login_approved != null ? this.is_login_approved.id : this.is_login_approved,
                remarks: this.remarks,
                approval_status: this.approval_status,
                bypass_external_verification: this.bypass_external_verification,
                role: typeof this.role == 'object' && this.role != null ? this.role.id : this.role,
                company: typeof this.company == 'object' && this.company != null ? this.company.id : this.company,
                country: typeof this.country == 'object' && this.country != null ? this.country.id : this.country,
                rejection_reason: typeof this.rejection_reason == 'object' && this.rejection_reason != null ? this.rejection_reason.id : this.rejection_reason,

            }
        } else {
            return {
                id: this.id,
                state: typeof this.state == 'object' && this.state != null ? this.state.id : this.state,
                is_active: this.is_active,
                email: this.email,
                first_name: this.first_name,
                last_name: this.last_name,
                phone: typeof this.phone == 'object' && this.phone != null ? this.phone.as_e164 : this.phone,
                company_name: this.company_name,
                address: this.address,
                has_registered: this.has_registered,
                is_otp_verified: this.is_otp_verified,
                // is_login_approved: this.is_login_approved,
                is_login_approved: typeof this.is_login_approved == 'object' && this.is_login_approved != null ? this.is_login_approved.id : this.is_login_approved,
                rejection_reason: typeof this.rejection_reason == 'object' && this.rejection_reason != null ? this.rejection_reason.id : this.rejection_reason,
                remarks: this.remarks,
                approval_status: this.approval_status,
                bypass_external_verification: this.bypass_external_verification,
                role: typeof this.role == 'object' && this.role != null ? this.role.id : this.role,
                company: typeof this.company == 'object' && this.company != null ? this.company.id : this.company,
                country: typeof this.country == 'object' && this.country != null ? this.country.id : this.country,

            }

        }
    }

    getUserVerificationSavePayload1() {
        console.log("before state",this.state)
        if (this.is_login_approved) {
            return {
                id: this.id,
                // state: typeof this.state == 'object' && this.state != null ? this.state.id : this.state,
                // is_active: true,
                email: this.email,
                first_name: this.first_name,
                last_name: this.last_name,
                phone: typeof this.phone == 'object' && this.phone != null ? this.phone.as_e164 : this.phone,
                company_name: typeof this.company_name == 'object' && this.company_name != null ? this.company_name.id : this.company_name,
                address: this.address,
                is_login_approved: this.is_login_approved,
                // remarks: this.remarks,
                // approval_status: this.approval_status,
                bypass_external_verification: this.bypass_external_verification,
                role: typeof this.role == 'object' && this.role != null ? this.role.id : this.role,
                company: typeof this.company == 'object' && this.company != null ? this.company.id : this.company,
                country: typeof this.country == 'object' && this.country != null ? this.country.id : this.country,
            }
        } else {
            return {
                id: this.id,
                state: typeof this.state == 'object' && this.state != null ? this.state.id : this.state,
                // is_active: true,
                email: this.email,
                first_name: this.first_name,
                last_name: this.last_name,
                phone: typeof this.phone == 'object' && this.phone != null ? this.phone.as_e164 : this.phone,
                company_name: this.company_name,
                address: this.address,
                is_login_approved: this.is_login_approved,
                rejection_reason: typeof this.rejection_reason == 'object' && this.rejection_reason != null ? this.rejection_reason.id : this.rejection_reason,
                // remarks: this.remarks,
                // approval_status: this.approval_status,
                bypass_external_verification: this.bypass_external_verification,
                role: typeof this.role == 'object' && this.role != null ? this.role.id : this.role,
                company: typeof this.company == 'object' && this.company != null ? this.company.id : this.company,
                country: typeof this.country == 'object' && this.country != null ? this.country.id : this.country,
            }

        }
    }
    saveUserPayload(data) {
        this.id = data.id;
        this.email = data.email;
        this.first_name = data.first_name;
        this.last_name = data.last_name;
        this.phone = data.phone;
        this.company_name = data.company_name;
        this.is_otp_verified = data.is_otp_verified;
    }

}

export interface ILeadCompanyModel {
    id: string
    group: string;
    name: string;
    legal_name: string;
    trade_name: string;
    state: string;
    address: string;
    master_agreement_no: string;
    master_agreement_valid_till: Date;
    length:any
}